import { useState } from 'react';
import {
    Typography,
    Box,
    Paper,
    TextField,
    Button,
    Alert,
    CircularProgress,
} from '@mui/material';
import { login } from '../../services/authService';

export function LoginForm({ onLogin }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        setLoading(true);
        
        try {
            const data = await login(email, password);
            
            if (!data.success) {
                setError(data.error || 'Credenciales incorrectas');
                return;
            }
            
            onLogin(data.user);
        } catch (err) {
            console.error('Error de login:', err);
            const message = err.response?.data?.error || 'Error de conexión';
            setError(message);
        } finally {
            setLoading(false);
        }
    }

    return (
        <Paper elevation={3} sx={{ p: 4, width: 380 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>Iniciar sesión</Typography>
            
            {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {error}
                </Alert>
            )}
            
            <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <TextField 
                    label="Email" 
                    variant="outlined" 
                    value={email} 
                    onChange={e => setEmail(e.target.value)} 
                    required 
                    autoComplete="email"
                />
                <TextField 
                    label="Contraseña" 
                    variant="outlined" 
                    type="password" 
                    value={password} 
                    onChange={e => setPassword(e.target.value)} 
                    required 
                    autoComplete="current-password"
                />
                <Button 
                    type="submit" 
                    variant="contained" 
                    color="primary"
                    disabled={loading}
                    sx={{ position: 'relative' }}
                >
                    {loading ? <CircularProgress size={24} /> : 'Entrar'}
                </Button>
            </Box>
        </Paper>
    );
}